<template>
    <div v-show="visible">
        <el-dialog title="配置分组" :close-on-click-modal="false" 
            :visible.sync="visible" :before-close="dialogClose" width="750px">


            <!--分组方案列表 -->
            <div class="container" v-if="!groupVisible">
                <div style="display: inline-block; height:40px;">
                    <el-button type="warning" @click="setAdd()">添加</el-button>
                </div>
                <div style="display: inline-block; height:40px;">
                    <el-button type="primary" @click="getData()">刷新</el-button>
                </div>
                <el-table
                    :data="data"
                    style="width: 100%;margin-bottom: 20px;"
                    height="480"
                    v-loading="loading"
                    element-loading-background = "rgba(255, 255,255,0.7)"
                    element-loading-text = "数据正在加载中..."
                    border fit highlight-current-row>
                    <el-table-column type="index" label="序号" width="50" :index="indexMethod"></el-table-column>
                    <el-table-column prop="name" label="分组方案名称" width="100"></el-table-column>
                    <el-table-column prop="groupCount" label="小组数量" width="80"></el-table-column>
                    <el-table-column label="创建者">
                        <template slot-scope="scope">
                            <div v-if="scope.row.userName == '' || scope.row.userName == null">
                                系统生成
                            </div>
                            <div v-else>
                                {{scope.row.userName}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="gmtModified" label="更新日期"></el-table-column>
                    <el-table-column prop="orderNum" label="排序号" width="60"></el-table-column>
                    <el-table-column label="操作" style="text-align:'left'" width="78">
                        <template slot-scope="scope">
                            <div v-if="scope.row.groupType == 1 
                                    && (form.userId == form.deptController || form.userId == 1)">
                                <el-button  @click.native.prevent="setUpdate(scope.row)"
                                    type="text"
                                    size="small">
                                    <span style="color: #387EE8;">修改分组</span>
                                </el-button>
                            </div>
                            <div v-if="scope.row.groupType == 2">
                                <el-button  @click.native.prevent="setUpdate(scope.row)"
                                    type="text"
                                    size="small">
                                    <span style="color: #387EE8;">修改分组</span>
                                </el-button>
                                <el-button  @click.native.prevent="setName(scope.row)"
                                    type="text"
                                    size="small">
                                    <span style="color: #387EE8;">修改名称</span>
                                </el-button>
                                <el-button style="color: red" @click.native.prevent="del(scope.row)"
                                    type="text"
                                    v-if="(scope.row.createBy == form.userId || form.userId == 1)"
                                    size="small">
                                    删除
                                </el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <!--分组方案编辑列表 -->
            <div class="container" v-if="groupVisible">
                <div style="display: inline-block; height:40px;">
                    <el-button type="warning" @click="setAddClassGroup()">添加</el-button>
                </div>
                <div style="display: inline-block; height:40px;">
                    <el-button type="primary" @click="getClassGroupData()">刷新</el-button>
                </div>
                <div style="display: inline-block; width:510px;height:40px; font-weight: bold; text-align: center;">
                    {{form.groupName}}
                </div>
                <div style="display: inline-block; height:40px;float: right;">
                    <el-button type="primary" @click="groupVisible=false;getData()">返回</el-button>
                </div>
                <el-table
                    :data="classGroupData"
                    style="width: 100%;margin-bottom: 20px;"
                    height="480"
                    v-loading="loading"
                    element-loading-background = "rgba(255, 255,255,0.7)"
                    element-loading-text = "数据正在加载中..."
                    border fit highlight-current-row>
                    <el-table-column type="index" label="序号" width="50" :index="indexMethod"></el-table-column>
                    <el-table-column prop="groupName" label="小组名称" width="100"></el-table-column>
                    <el-table-column prop="userCount" label="绑定人数" width="80"></el-table-column>
                    <el-table-column prop="userName" label="绑定学生" :show-overflow-tooltip="true" ></el-table-column>
                    <el-table-column prop="orderNum" label="排序号" width="60"></el-table-column>
                    <el-table-column label="操作" style="text-align:'left'" width="100">
                        <template slot-scope="scope">
                            <el-button  @click.native.prevent="setUpdateClassGroup(scope.row)"
                                type="text"
                                size="small">
                                <span style="color: #387EE8;">修改</span>
                            </el-button>
                            <el-button style="color: red" @click.native.prevent="delClassGroup(scope.row)"
                                type="text"
                                size="small">
                                删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </el-dialog>

        <!-- 新增/修改弹出框 -->
        <div v-if="addVisible">
            <add ref="add"></add>
        </div>
        <div v-if="updateVisible">
            <update ref="update"></update>
        </div>
         <!-- 新增/修改弹出框 -->
        <div v-if="addClassGroupVisible">
            <addClassGroup ref="addClassGroup"></addClassGroup>
        </div>
        <div v-if="updateClassGroupVisible">
            <updateClassGroup ref="updateClassGroup"></updateClassGroup>
        </div>
    </div>
</template>
 
<script>
    import http from '../../../../../common/http';
    import add from './add.vue';
    import update from './update.vue';
    import addClassGroup from './addClassGroup.vue';
    import updateClassGroup from './updateClassGroup.vue';

	export default {
         data(){
            return{
                loading:false,
                visible:false,
                addVisible:false,
                updateVisible:false,
                addClassGroupVisible:false,
                updateClassGroupVisible:false,
                form:{
                    id: "",
                    userId: "",
                    classId: "",
                    deptController: "",
                    currentUserId: ""
                },
                data: [],
                classGroupData: [],
                groupVisible: false
            }
        },
        created:function () {
        },
        components: {
            add,update,addClassGroup,updateClassGroup
        },
        methods:{
            indexMethod(index) {
                return index+1;
            },
            init(userId,classId){
                this.groupVisible = false
                this.visible=true

                this.form.userId = userId
                this.form.classId = classId
                this.getData()
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            // 分组方案列表-查，增，改，删
            getData(){
                //用户管理
                let url  = this.groupSchemeListUrl;
                let data = {
                    userId:this.form.userId,
                    classId:this.form.classId
                };
                this.loading=true;
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                       this.data=res.data.dataList;
                       this.form.deptController=res.data.deptController;
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                    this.loading=false;
                },(err)=>{
                    console.log(err);
                    this.loading=false;
                });

            },
            //新增界面
            setAdd(){
                this.addVisible=true;
                this.$nextTick(() => {
                    this.$refs['add'].init(this.data, this.form.userId, this.form.classId);
                })
            },
            //修改小组界面
            setName(data){
                this.updateVisible=true;
                this.$nextTick(() => {
                    this.$refs['update'].init(data, this.form.userId);
                })
            },
            //修改小组界面
            setUpdate(data){
                this.classGroupData=[]
                this.groupVisible=true
                this.form.groupSchemeId = data.id
                this.form.groupName = data.name
                console.log('groupSchemeId：',data.id,';groupName：',data.name)
                this.getClassGroupData();
            },
            //删除
            del(data){
                this.form.id = data.id;
                this.$commonFn.showConfirm(this.delSuccess);
            },
            delSuccess(){
                let url = this.groupSchemeRemoveUrl;
                let data = {
                    id:this.form.id
                };
                this.apiPost(url,data).then((res)=>{
                    if(res.status === 200){
                        this.$commonFn.showTip(res.message,1);
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                })
            },
            // 分组方案编辑列表-查，增，改，删
            getClassGroupData(){
                //用户管理
                let url  = this.setClassBindGroupListPCUrl;
                let data = {
                    userId: this.form.userId,
                    classId: this.form.classId,
                    groupSchemeId:this.form.groupSchemeId,
                };
                this.loading=true;
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                    this.classGroupData=res.data;
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                    this.loading=false;
                },(err)=>{
                    console.log(err);
                    this.loading=false;
                });

            },
            //新增界面
            setAddClassGroup(){
                this.addClassGroupVisible=true;
                this.$nextTick(() => {
                    this.$refs['addClassGroup'].init(this.classGroupData, this.form.groupSchemeId, this.form.userId, this.form.classId);
                })
            },
            //修改界面
            setUpdateClassGroup(data){
                this.updateClassGroupVisible=true;
                this.$nextTick(() => {
                    this.$refs['updateClassGroup'].init(data, this.form.groupSchemeId, this.form.userId, this.form.classId);
                })
            },
            //删除
            delClassGroup(data){
                this.form.id = data.id;
                this.$commonFn.showConfirm(this.delClassGroupSuccess);
            },
            delClassGroupSuccess(){
                let url = this.setClassBindGroupRemovePCUrl;
                let data = {
                    id:this.form.id
                };
                this.apiPost(url,data).then((res)=>{
                    if(res.status === 200){
                        this.$commonFn.showTip(res.message,1);
                        this.getClassGroupData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                })
            },

        },
        mixins: [http]
	}
</script>

<style scoped>
	 
</style>



// WEBPACK FOOTER //
// src/components/page/set/classroomtime/group/list.vue